/* src/components/Toolbar/components/Slider.svelte generated by Svelte v3.54.0 */
import {
	SvelteComponent,
	append,
	attr,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	run_all,
	safe_not_equal,
	set_input_value,
	set_style,
	to_number,
	toggle_class
} from "svelte/internal";

import { createEventDispatcher } from "svelte";

function create_fragment(ctx) {
	let div;
	let input;
	let input_class_value;
	let div_class_value;
	let mounted;
	let dispose;

	return {
		c() {
			div = element("div");
			input = element("input");
			attr(input, "class", input_class_value = "" + (name + "-track " + /*theme*/ ctx[2]));
			attr(input, "type", "range");
			attr(input, "role", "slider");
			input.disabled = /*disabled*/ ctx[6];
			attr(input, "min", /*min*/ ctx[3]);
			attr(input, "max", /*max*/ ctx[4]);
			attr(input, "step", /*step*/ ctx[5]);
			attr(input, "aria-valuemin", /*min*/ ctx[3]);
			attr(input, "aria-valuemax", /*max*/ ctx[4]);
			attr(input, "aria-valuenow", /*value*/ ctx[0]);
			toggle_class(input, "grabbing", /*grabbing*/ ctx[8]);
			attr(div, "class", div_class_value = "" + (name + " " + /*className*/ ctx[1] + " " + /*theme*/ ctx[2]));
			set_style(div, "--value", /*percent*/ ctx[9] + "%");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, input);
			set_input_value(input, /*real_value*/ ctx[7]);

			if (!mounted) {
				dispose = [
					listen(input, "change", /*input_change_input_handler*/ ctx[12]),
					listen(input, "input", /*input_change_input_handler*/ ctx[12]),
					listen(input, "pointerdown", /*on_down*/ ctx[10]),
					listen(input, "change", /*on_change*/ ctx[11])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*theme*/ 4 && input_class_value !== (input_class_value = "" + (name + "-track " + /*theme*/ ctx[2]))) {
				attr(input, "class", input_class_value);
			}

			if (dirty & /*disabled*/ 64) {
				input.disabled = /*disabled*/ ctx[6];
			}

			if (dirty & /*min*/ 8) {
				attr(input, "min", /*min*/ ctx[3]);
			}

			if (dirty & /*max*/ 16) {
				attr(input, "max", /*max*/ ctx[4]);
			}

			if (dirty & /*step*/ 32) {
				attr(input, "step", /*step*/ ctx[5]);
			}

			if (dirty & /*min*/ 8) {
				attr(input, "aria-valuemin", /*min*/ ctx[3]);
			}

			if (dirty & /*max*/ 16) {
				attr(input, "aria-valuemax", /*max*/ ctx[4]);
			}

			if (dirty & /*value*/ 1) {
				attr(input, "aria-valuenow", /*value*/ ctx[0]);
			}

			if (dirty & /*real_value*/ 128) {
				set_input_value(input, /*real_value*/ ctx[7]);
			}

			if (dirty & /*theme, grabbing*/ 260) {
				toggle_class(input, "grabbing", /*grabbing*/ ctx[8]);
			}

			if (dirty & /*className, theme*/ 6 && div_class_value !== (div_class_value = "" + (name + " " + /*className*/ ctx[1] + " " + /*theme*/ ctx[2]))) {
				attr(div, "class", div_class_value);
			}

			if (dirty & /*percent*/ 512) {
				set_style(div, "--value", /*percent*/ ctx[9] + "%");
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
			mounted = false;
			run_all(dispose);
		}
	};
}

const name = "fastboard-slider";

function instance($$self, $$props, $$invalidate) {
	let percent;
	const dispatch = createEventDispatcher();
	let { class: className = "" } = $$props;
	let { theme = "light" } = $$props;
	let { min = 0 } = $$props;
	let { max = 100 } = $$props;
	let { step = 0.01 } = $$props;
	let { value = 30 } = $$props;
	let { disabled = false } = $$props;
	let real_value = value;
	let grabbing = false;

	function on_down() {
		$$invalidate(8, grabbing = true);
	}

	function on_change() {
		$$invalidate(8, grabbing = false);
		$$invalidate(0, value = real_value);
		dispatch("change", value);
	}

	function input_change_input_handler() {
		real_value = to_number(this.value);
		(($$invalidate(7, real_value), $$invalidate(0, value)), $$invalidate(8, grabbing));
	}

	$$self.$$set = $$props => {
		if ('class' in $$props) $$invalidate(1, className = $$props.class);
		if ('theme' in $$props) $$invalidate(2, theme = $$props.theme);
		if ('min' in $$props) $$invalidate(3, min = $$props.min);
		if ('max' in $$props) $$invalidate(4, max = $$props.max);
		if ('step' in $$props) $$invalidate(5, step = $$props.step);
		if ('value' in $$props) $$invalidate(0, value = $$props.value);
		if ('disabled' in $$props) $$invalidate(6, disabled = $$props.disabled);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*value, real_value, grabbing*/ 385) {
			$: if (value !== real_value && !grabbing) {
				$$invalidate(7, real_value = value);
			}
		}

		if ($$self.$$.dirty & /*real_value, min, max*/ 152) {
			$: $$invalidate(9, percent = 100 * (real_value - min) / (max - min));
		}
	};

	return [
		value,
		className,
		theme,
		min,
		max,
		step,
		disabled,
		real_value,
		grabbing,
		percent,
		on_down,
		on_change,
		input_change_input_handler
	];
}

class Slider extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			class: 1,
			theme: 2,
			min: 3,
			max: 4,
			step: 5,
			value: 0,
			disabled: 6
		});
	}
}

export default Slider;